import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { isPublicAppRoute, LOCAL_VAR } from '@app/core/constants';

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authenticationService.isAuthenticated()) {
      return true;
    }

    // Public auth URLs must not be redirected to login by this guard
    if (isPublicAppRoute(state.url)) {
      return false;
    }

    let queryParams = {};
    if (state.root.queryParams.invitationCode) {
      queryParams = { invitationCode: state.root.queryParams.invitationCode };
    }

    console.log('Not authenticated, redirecting...');
    localStorage.removeItem(LOCAL_VAR.selectedAgent);
    this.authenticationService.logout(true).subscribe(() => {
      this.router.navigate(['/login'], {
        replaceUrl: true,
        queryParams: queryParams
      });
    });
    return false;
  }
}
